import { SlotGame } from "@nolimitcity/slot-game/bin/SlotGame";
import { AssetLoader } from "@nolimitcity/slot-game/bin/asset/AssetLoader";
import { AssetsConfig } from "@nolimitcity/slot-game/bin/asset/AssetsConfig";
import { ResourcesGroupName } from "@nolimitcity/slot-game/bin/asset/ResourcesGroupName";
import { FlowState } from "@nolimitcity/slot-game/bin/flowcontrol/FlowState";
import { GameFlowController } from "@nolimitcity/slot-game/bin/flowcontrol/GameFlowController";
import { NolimitApplication } from "@nolimitcity/slot-launcher/bin/NolimitApplication";
import { NolimitPlugin } from "@nolimitcity/slot-launcher/bin/NolimitPlugin";
import { FontLoader } from "@nolimitcity/slot-launcher/bin/loader/FontLoader";
import {
    TemplateAsset,
    TemplateLoader,
} from "@nolimitcity/slot-launcher/bin/loader/TemplateLoader";
import { OpenSans } from "@nolimitcity/slot-launcher/bin/loader/font/OpenSans";
import { LogLevel } from "@nolimitcity/slot-launcher/bin/utils/Logger";

import { EventsManager, GameEvents } from "../abstracts/events/EventsManager";
import {
    AbstractFlowPresentation,
    setModelForFlowPresentation,
} from "../abstracts/flow/AbstractFlowStatePresentation";
import { AbstractGameMode } from "../abstracts/flow/AbstractGameMode";
import { setAssetsLoader } from "../abstracts/graphics/AbstractSpine";
import {
    AbstractModuleController,
    setModelForModulesController,
} from "../abstracts/modules/AbstractModuleController";
import { initializeGameLogger } from "../abstracts/utils/AbstractConsole";
import { AbstractTimelineController } from "../abstracts/utils/AbstractTimelineController";
import { playSound } from "../abstracts/utils/SoundUtils";
import { ApocalypseAssetsLoader, ApocalypseTTF } from "./assetsLoader/ApocalypseAssetsLoader";
import { ApocalypseSoundNames } from "./assetsLoader/ApocalypseAssetsNames";
import { devDebugConfig } from "./config/ApocalypseConfig";
import { ApocalypseFreespinBetPresentation } from "./flow/freespin/ApocalypseFreespinBetPresentation";
import { ApocalypseFreespinIdlePresentation } from "./flow/freespin/ApocalypseFreespinIdlePresentation";
import { ApocalypseFreespinResultPresentation } from "./flow/freespin/ApocalypseFreespinResultPresentation";
import { ApocalypseFreespinWinPresentation } from "./flow/freespin/ApocalypseFreespinWinPresentation";
import { ApocalypseFreespinBetterBetPresentation } from "./flow/freespinBetter/ApocalypseFreespinBetterBetPresentation";
import { ApocalypseFreespinBetterIdlePresentation } from "./flow/freespinBetter/ApocalypseFreespinBetterIdlePresentation";
import { ApocalypseFreespinBetterResultPresentation } from "./flow/freespinBetter/ApocalypseFreespinBetterResultPresentation";
import { ApocalypseFreespinBetterWinPresentation } from "./flow/freespinBetter/ApocalypseFreespinBetterWinPresentation";
import { ApocalypseNormalBetPresentation } from "./flow/normal/ApocalypseNormalBetPresentation";
import { ApocalypseNormalResultPresentation } from "./flow/normal/ApocalypseNormalResultPresentation";
import { ApocalypseNormalWinPresentation } from "./flow/normal/ApocalypseNormalWinPresentation";
import { ApocalypseNormalIdlePresentation } from "./flow/normal/ApocalypseNormaldlePresentation";
import { ApocalypseSuperFreespinBetPresentation } from "./flow/superFreespin/ApocalypseSuperFreespinBetPresentation";
import { ApocalypseSuperFreespinIdlePresentation } from "./flow/superFreespin/ApocalypseSuperFreespinIdlePresentation";
import { ApocalypseSuperFreespinResultPresentation } from "./flow/superFreespin/ApocalypseSuperFreespinResultPresentation";
import { ApocalypseSuperFreespinWinPresentation } from "./flow/superFreespin/ApocalypseSuperFreespinWinPresentation";
import { ApocalypseModel } from "./model/ApocalypseModel";
import { ApocalypseBackgroundController } from "./modules/Background/ApocalypseBackgroundController";
import { ApocalypseReelsController } from "./modules/Reels/ApocalypseReelsController";
import { ApocalypseSoundController } from "./modules/Sound/ApocalypseSoundController";
import { ApocalypseWinController } from "./modules/Winnings/ApocalypseWinController";
import { ISymbolValues } from "./types/ApocalypseInterfaces";
import { ApocalypseSoundDebugger } from "./utils/ApocalypseSoundDebugger";
import {Skinner} from "@nolimitcity/slot-launcher/bin/utils/Skinner";
import {APIEvent} from "@nolimitcity/slot-launcher/bin/interfaces/APIEventSystem";

export class Apocalypse extends SlotGame {
    public static model: ApocalypseModel;
    public static assetLoader: AssetLoader;
    public static gameFlowController: GameFlowController;
    private skinner:Skinner;
    constructor() {
        super();
        const validSkins:string[] = [
            "sweep"
        ]
        this.skinner = new Skinner(validSkins);
    }

    private _defaultSymbolValues: ISymbolValues = {
        L1: { 3: 2, 4: 4, 5: 10, 6: 16 },
        L2: { 3: 2, 4: 4, 5: 8, 6: 14 },
        L3: { 3: 1, 4: 2, 5: 8, 6: 12 },
        L4: { 3: 1, 4: 2, 5: 6, 6: 10 },
        L5: { 3: 1, 4: 2, 5: 4, 6: 8 },
        M1: { 3: 4, 4: 10, 5: 30, 6: 50 },
        M2: { 3: 4, 4: 8, 5: 20, 6: 30 },
        M3: { 3: 3, 4: 5, 5: 14, 6: 24 },
        M4: { 3: 3, 4: 5, 5: 13, 6: 22 },
        M5: { 3: 3, 4: 5, 5: 13, 6: 20 },
    };

    public getSymbolString(key: string, data: { [numSymbols: number]: number }): string {
        return `
            <div class="symbol">
            <img src="{{gamePath}}screens/images/symbols/${key}.png">
            <div class="payout-group">
            <div class="payout">
                    <span class="number">6</span>
                    <span class="multiplier" data-multiplier="${data[6] * 0.05}">${
            data[6] * 0.05
        }</span>
                </div>
                 <div class="payout">
                    <span class="number">5</span>
                    <span class="multiplier" data-multiplier="${data[5] * 0.05}">${
            data[5] * 0.05
        }</span>
                </div>
                <div class="payout">
                    <span class="number">4</span>
                    <span class="multiplier" data-multiplier="${data[4] * 0.05}">${
            data[4] * 0.05
        }</span>
                </div>
                <div class="payout">
                    <span class="number">3</span>
                    <span class="multiplier" data-multiplier="${data[3] * 0.05}">${
            data[3] * 0.05
        }</span>
                </div>
            </div>
            </div>
        `;
    }


    private paytable:string = require("../../nolimit/screens/paytable.mustache");
    public getPaytable(): Promise<string> {
        return new Promise((resolve, reject) => {
            let symbolDataValueData = this._defaultSymbolValues;
            if (Apocalypse.model.initData.symbolValues) {
                symbolDataValueData = Apocalypse.model.initData.symbolValues;
            }
            const data = {
                skinPath:"screens/images/"
            };

            if (this.skinner.skinId != undefined){
                data.skinPath = `../resources/images/${this.skinner.skinId}/`;
            }
            let paytableString:string = (<any>this.paytable).text;
            paytableString = paytableString.replace(/{{skinPath}}/g, data.skinPath);
            for (let key in symbolDataValueData) {
                paytableString = paytableString.replace(
                    `{{${key}}}`,
                    this.getSymbolString(key, symbolDataValueData[key])
                );
            }
            resolve(paytableString);
        });
    }

    private registerModules(): void {
        let layerIndex: number = 0;

        const addController = (controller: AbstractModuleController) => {
            if (controller.view.isDisabled) {
                return;
            }

            NolimitApplication.addLayerAt(
                controller.name.replace(`Controller`, ``) + `-layer`,
                controller.view,
                layerIndex
            );
            layerIndex++;
        };

        //add them in the order you need them displayed
        addController(new ApocalypseBackgroundController());
        addController(new ApocalypseReelsController());
        // addController(new ApocalypseUserInterfaceController());
        addController(new ApocalypseWinController());
        addController(new ApocalypseSoundController());
    }

    public init(): Promise<NolimitPlugin> {
        return super.init().then((value: NolimitPlugin) => {
            Apocalypse.model = new ApocalypseModel(SlotGame.apiPlugin, true);

            setModelForModulesController(Apocalypse.model);
            setModelForFlowPresentation(Apocalypse.model);
            initializeGameLogger(`Apocalypse`);

            Apocalypse.gameFlowController = new GameFlowController(
                SlotGame.apiPlugin,
                Apocalypse.model
            );
            Apocalypse.gameFlowController.flowStateLogger.level = LogLevel.DEV;

            //IDLE
            const normalIdle = new ApocalypseNormalIdlePresentation();
            const freespinIdle = new ApocalypseFreespinIdlePresentation();
            const superFreespinIdle = new ApocalypseSuperFreespinIdlePresentation();
            const freespinBetterIdle = new ApocalypseFreespinBetterIdlePresentation();

            //BET
            const normalBet = new ApocalypseNormalBetPresentation();
            const freespinBet = new ApocalypseFreespinBetPresentation();
            const superFreespinBet = new ApocalypseSuperFreespinBetPresentation();
            const freespinBetterBet = new ApocalypseFreespinBetterBetPresentation();

            //RESULT
            const normalResult = new ApocalypseNormalResultPresentation();
            const freespinResult = new ApocalypseFreespinResultPresentation();
            const superFreespinResult = new ApocalypseSuperFreespinResultPresentation();
            const freespinBetterResult = new ApocalypseFreespinBetterResultPresentation();

            //WIN
            const normalWin = new ApocalypseNormalWinPresentation();
            const freespinWin = new ApocalypseFreespinWinPresentation();
            const superFreespinWin = new ApocalypseSuperFreespinWinPresentation();
            const freespinBetterWin = new ApocalypseFreespinBetterWinPresentation();

            Apocalypse.gameFlowController.addGameModeFlowStatePresentationMap(
                AbstractGameMode.NORMAL,
                new Map<FlowState, AbstractFlowPresentation>([
                    [FlowState.IDLE, normalIdle],
                    [FlowState.BET, normalBet],
                    [FlowState.RESULT, normalResult],
                    [FlowState.WIN, normalWin],
                ])
            );

            Apocalypse.gameFlowController.addGameModeFlowStatePresentationMap(
                AbstractGameMode.FREESPIN,
                new Map<FlowState, AbstractFlowPresentation>([
                    [FlowState.IDLE, freespinIdle],
                    [FlowState.BET, freespinBet],
                    [FlowState.RESULT, freespinResult],
                    [FlowState.WIN, freespinWin],
                ])
            );

            Apocalypse.gameFlowController.addGameModeFlowStatePresentationMap(
                AbstractGameMode.SUPER_FREESPIN,
                new Map<FlowState, AbstractFlowPresentation>([
                    [FlowState.IDLE, superFreespinIdle],
                    [FlowState.BET, superFreespinBet],
                    [FlowState.RESULT, superFreespinResult],
                    [FlowState.WIN, superFreespinWin],
                ])
            );

            Apocalypse.gameFlowController.addGameModeFlowStatePresentationMap(
                AbstractGameMode.FREESPIN_BETTER,
                new Map<FlowState, AbstractFlowPresentation>([
                    [FlowState.IDLE, freespinBetterIdle],
                    [FlowState.BET, freespinBetterBet],
                    [FlowState.RESULT, freespinBetterResult],
                    [FlowState.WIN, freespinBetterWin],
                ])
            );

            //Making sure that skinID is set based  on "replaceWordFree" gcc.
            if (SlotGame.apiPlugin.gameClientConfiguration.isSet){
                if (SlotGame.apiPlugin.gameClientConfiguration.sweepGfx){
                    this.skinner.skinId = "sweep";
                }
            }
            else {
                SlotGame.apiPlugin.events.on(APIEvent.GAME_CLIENT_CONFIGURATION_APPLIED,()=>{
                    if (SlotGame.apiPlugin.gameClientConfiguration.sweepGfx){
                        this.skinner.skinId = "sweep";
                    }
                })
            }
            //xbet

            return value;
        });
    }

    public getReady(): Promise<NolimitPlugin> {
        //Show intro and load game AssetsModule
        return super.getReady().then((value: NolimitPlugin) => {
            const fontLoader = new FontLoader(NolimitApplication.resourcePath);
            fontLoader.add(OpenSans.ITALIC_600);
            fontLoader.add(OpenSans.NORMAL_300);
            fontLoader.add(OpenSans.NORMAL_400);
            fontLoader.add(OpenSans.NORMAL_700);
            fontLoader.add(ApocalypseTTF.NORMAL);

            AssetsConfig.addToAssetsConfig(ApocalypseAssetsLoader.RESOURCES_GROUPS);
            Apocalypse.assetLoader = new AssetLoader(
                Apocalypse.apiPlugin,
                NolimitApplication.resourcePath + `/resources/`
            );
            setAssetsLoader(Apocalypse.assetLoader);

            const allPromises = [
                fontLoader.load(),
                Apocalypse.assetLoader.load(ResourcesGroupName.MAIN),
            ]
            if (this.skinner.skinId != undefined) {
                const replaceMap:Map<string, string> = new Map();
                //Bonus
                replaceMap.set("pageImage_6", "pageImage_6.png")
                replaceMap.set("BOOSTED_BET", "BOOSTED_BET.png");
                allPromises.push(this.skinner.loadSkin(replaceMap));
            }
            const promises = Promise.all(allPromises);

            return promises.then(() => {
                this.registerModules();

                devDebugConfig.showTimelineController && new AbstractTimelineController();
                devDebugConfig.showSoundDebugger && new ApocalypseSoundDebugger();

                Apocalypse.apiPlugin.freeBets.events.on(
                    Apocalypse.apiPlugin.freeBets.FREE_BETS_START,
                    () => {
                        EventsManager.trigger(GameEvents.ON_FREE_BETS_START);

                        Apocalypse.apiPlugin.freeBets.events.once(
                            Apocalypse.apiPlugin.freeBets.FREE_BETS_END,
                            () => {
                                EventsManager.trigger(GameEvents.ON_FREE_BETS_END);
                            }
                        );
                    }
                );

                return value;
            });
        });
    }

    public getReadyToStart(): Promise<NolimitPlugin> {
        //Game assets loaded, waiting for user to start game.

        return super.getReadyToStart().then((value: NolimitPlugin) => {
            return value;
        });
    }

    public start(): Promise<NolimitPlugin> {
        playSound({ name: ApocalypseSoundNames.CONTINUE_BUTTON });
        //User has pressed continue and the game starts.
        return super.start().then((value: NolimitPlugin) => {
            Apocalypse.gameFlowController.start();

            return value;
        });
    }

    public getNoWinGameData(): any {
        return {
            accumulatedRoundWin: 0,
            addedNumberOfFreespinsThisSpin: 0,
            betWayWins: [],
            brokeTheBank: false,
            enhancedBet: false,
            evaluatedArea: [
                [`M1`, `L2`, `L4`, `L5`],
                [`L1`, `L2`, `L4`, `L5`],
                [`L1`, `L3`, `L3`, `L3`],
                [`L1`, `L3`, `L3`, `L4`],
                [`L1`, `L3`, `L3`, `L4`],
                [`L1`, `L2`, `L3`, `L4`],
            ],
            featureName: `NULL`,
            featuresMapFSM5: {},
            featuresMapForStageTwo: {},
            firstStage: false,
            freespinsLeft: 0,
            fullReels: [false, false, false, false, false, false],
            gameAreaSize: [4, 4, 4, 4, 4, 4],
            mode: `NORMAL`,
            nextMode: `NORMAL`,
            nudgeMultiplier: [1, 1, 1, 1, 1, 1],
            numberOfFreespinsPlayed: 0,
            persistentRows: [
                [false, false],
                [false, false],
                [false, false],
                [false, false],
                [false, false],
                [false, false],
            ],
            playedBetValue: 1,
            reels: [
                [`X`, `M1`, `L2`, `L4`, `L5`, `X`],
                [`X`, `L1`, `L2`, `L4`, `L5`, `X`],
                [`X`, `L1`, `L3`, `L3`, `L3`, `X`],
                [`X`, `L1`, `L3`, `L3`, `L4`, `X`],
                [`X`, `L1`, `L3`, `L3`, `L4`, `X`],
                [`X`, `L1`, `L2`, `L3`, `L4`, `X`],
            ],
            secondStage: false,
            secondStageFsLeft: 0,
            symbolSizes: [
                [1, 1, 1, 1],
                [1, 1, 1, 1],
                [1, 1, 1, 1],
                [1, 1, 1, 1],
                [1, 1, 1, 1],
                [1, 1, 1, 1],
            ],
            symbolSizesBeforeUpdates: [
                [1, 1, 1, 1],
                [1, 1, 1, 1],
                [1, 1, 1, 1],
                [1, 1, 1, 1],
                [1, 1, 1, 1],
                [1, 1, 1, 1],
            ],
            thisSpinWinning: 0,
            totalFSWininning: 0,
            totalSpinWinnings: 0,
            wasFeatureBuy: false,
            winMatrixFs: [
                [0, 0, 0, 0, 0, 0],
                [0, 0, 0, 0, 0, 0],
                [0, 0, 0, 0, 0, 0],
                [0, 0, 0, 0, 0, 0],
                [0, 0, 0, 0, 0, 0],
                [0, 0, 0, 0, 0, 0],
            ],
        };
    }
}
